import type { TPageLoadAction } from 'core/product/PageLoadActionProcessor';

/**
 * @description Base EnrollLoyaltyToBuyModalMixin implementation
 * @param DrawerDialog Base widget for extending
 * @returns EnrollLoyaltyToBuyModalMixin class
 */
function EnrollLoyaltyToBuyModalMixinClassCreator(DrawerDialog: import('core/global/drawerDialog').TDrawerDialog) {
    class EnrollLoyaltyToBuyModalMixin extends DrawerDialog {
        pageLoadAction?: TPageLoadAction;

        init() {
            super.init();

            this.eventBus().on('enrollLoyaltyToBuyModal.show', 'showEnrollLoyaltyToBuyModal');
        }

        /**
         * @description Show modal dialog with join loyalty to buy content
         * @param templateData Data for rendering modal
         * @param cb Callback function to execute after modal is shown
         */
        showEnrollLoyaltyToBuyModal(templateData?: Record<string, unknown>, cb?: () => void): Promise<void> {
            this.pageLoadAction = <TPageLoadAction>templateData?.pageLoadAction;

            return this.showModal(templateData, cb);
        }

        /**
         * @description Handles enroll loyalty to buy form submit
         */
        handleEnrollLoyaltyToBuyFormSubmit() {
            this.eventBus().emit('addPageLoadAction', this.pageLoadAction);
        }
    }

    return EnrollLoyaltyToBuyModalMixin;
}

export type TEnrollLoyaltyToBuyModalMixin = ReturnType<typeof EnrollLoyaltyToBuyModalMixinClassCreator>;

export type TEnrollLoyaltyToBuyModalMixinInstance = InstanceType<TEnrollLoyaltyToBuyModalMixin>;

export default EnrollLoyaltyToBuyModalMixinClassCreator;
